import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button, Form, InputGroup, Card } from "react-bootstrap";

import { UpdateDepartmentName, UpdateDepartmentDescription, UpdateDepartmentState, ClearDepartmentState } from "../../Store";
import { getAllDepartments, createDepartment, updateDepartment, deleteDepartment } from "../../Store/Thunk";

export default function Department() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const departmentList = useSelector((state) => state.organization.departmentList);
  const departmentName = useSelector((state) => state.organization.departmentName);
  const departmentDescription = useSelector((state) => state.organization.departmentDescription);
  const departmentId = useSelector((state) => state.organization.departmentId);
  const isUpdateOperation = useSelector((state) => state.organization.isDepartmentUpdateOperation);

  useEffect(() => {
    dispatch(getAllDepartments());
  }, [dispatch]);

  const submitForm = (event) => {
    event.preventDefault();

    if (isUpdateOperation) {
      dispatch(
        updateDepartment({
          id: departmentId,
          name: departmentName,
          description: departmentDescription,
        })
      );
    } else {
      dispatch(
        createDepartment({
          name: departmentName,
          description: departmentDescription,
        })
      );
    }

    dispatch(ClearDepartmentState());
  };

  const handleUpdateButton = (item) => {
    dispatch(
      UpdateDepartmentState({
        id: item.id,
        name: item.name,
        description: item.description || "",
        isUpdateOperation: true,
      })
    );
  };

  const handleDeleteButton = (id) => {
    dispatch(deleteDepartment(id));
  };

  return (
    <div>
      <Card body className="mb-3 default-card admin-form">
        <Form onSubmit={submitForm}>
          <Row>
            <Col xs={12} md={5}>
              <h6>{isUpdateOperation ? `${t("update")}: ${departmentId}` : t("departmentName")}</h6>
              <InputGroup className="mb-3">
                <Form.Control
                  required
                  name="name"
                  placeholder={t("enterDepartmentName")}
                  value={departmentName}
                  onChange={(e) => dispatch(UpdateDepartmentName(e.target.value))}
                />
              </InputGroup>
            </Col>
            <Col xs={12} md={5}>
              <h6>{t("description")}</h6>
              <InputGroup className="mb-3">
                <Form.Control
                  name="description"
                  placeholder={t("enterDescription")}
                  value={departmentDescription}
                  onChange={(e) => dispatch(UpdateDepartmentDescription(e.target.value))}
                />
              </InputGroup>
            </Col>
            <Col xs={12} md={2}>
              <Row style={{ height: !isUpdateOperation && "100%", margin: 0 }}>
                <Button
                  className="mb-1"
                  type="submit"
                  style={{ width: "100%", height: "100%" }}
                  variant="primary"
                  disabled={!departmentName}
                >
                  {isUpdateOperation ? t("update") : t("create")}
                </Button>
              </Row>
              {isUpdateOperation && (
                <Row style={{ margin: 0 }}>
                  <Button
                    style={{ width: "100%", height: "100%" }}
                    variant="secondary"
                    onClick={() => dispatch(ClearDepartmentState())}
                  >
                    {t("decline")}
                  </Button>
                </Row>
              )}
            </Col>
          </Row>
        </Form>
      </Card>

      <h5>{t("departmentList")}</h5>
      {departmentList &&
        departmentList.map((item, i) => (
          <Card className="mb-2" key={"department" + i}>
            <Card.Body>
              <Row className="align-items-center">
                <Col xs={1}>{item.id}</Col>
                <Col xs={3}>{item.name}</Col>
                <Col xs={5}>{item.description}</Col>
                <Col xs={3}>
                  <Row xs="auto" className="justify-content-end">
                    <Col>
                      <Button size="sm" variant="success" onClick={() => handleUpdateButton(item)}>
                        {t("updateButtonLabel")}
                      </Button>
                    </Col>
                    <Col>
                      <Button size="sm" variant="danger" onClick={() => handleDeleteButton(item.id)}>
                        {t("deleteButtonLabel")}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
    </div>
  );
}
